import React, { memo } from "react";

import { makeStyles } from "@material-ui/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  icon: {
    width: "0.9375rem",
    height: "0.9375rem",
  },
});

const RadioIcon = ({ checked }) => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 15 15" className={styles.icon} fill="none">
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="15"
        height="15"
      >
        <path d="M0 0H15V15H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <circle cx="7.5" cy="7.5" r="5.625" fill="black" />
        <circle cx="7.5" cy="7.5" r="4.6875" fill="white" />
        {checked && <circle cx="7.5" cy="7.5" r="2.8125" fill="black" />}
      </g>
    </SvgIcon>
  );
};

export default memo(RadioIcon);
